import React from "react"

import Art4dPage from "../../Routes/Work/Art4dPage"

const Work = () => {
  return <Art4dPage />
}

export default Work
